export const GoogleMapApiConfig = 'AIzaSyCqh042LeIwdoGQrK6oJofdx2-FukrPES4';